import { API_BASE_URL } from '../config/api';

// Best effort: callers do not await this, so authentication is never delayed.
// No passwords, refresh tokens, email addresses or error messages are sent.
// Identity comes from the verified Authorization header on successful reports.
export async function reportAuthEvent(event, result, idToken, diagnostics) {
  let timeout;
  try {
    const controller = new AbortController();
    timeout = setTimeout(() => controller.abort(), 5000);
    await fetch(`${API_BASE_URL}/auth/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}) },
      body: JSON.stringify({ event, result, ...(diagnostics ? { diagnostics } : {}) }),
      signal: controller.signal,
      keepalive: true,
    });
  } catch { /* Unavailable telemetry must not block authentication. */ }
  finally { clearTimeout(timeout); }
}
